import { NgIf } from '@angular/common';
import { Component, Input, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { FormDataService } from '../../../Services/Form Data/form-data.service';
import { DataService } from '../../../Services/Data Service/data.service';
import { AuthService } from '../../../Auth/auth.service';
import { firstValueFrom, forkJoin, switchMap, take } from 'rxjs';
import { FormUpdateService } from '../../../Services/Form Data/formupdate.service';
import { DisableAutocompleteDirective } from '../../../disable-autocomplete.directive';

@Component({
  selector: 'app-f-health-safety',
  standalone: true,
  imports: [FormsModule, NgIf, DisableAutocompleteDirective],
  templateUrl: './f-health-safety.component.html',
  styleUrl: './f-health-safety.component.css'
})
export class FHealthSafetyComponent {
  @Input() isViewOnly: boolean = false;
  @Input() formData: any; 
  
  hse_docs: any;
  error_message= '';

  loading = false;
  currUser: any;
  savedMessage = '';
  exists = false;

  agreedSustainability: boolean = false;

  constructor(
    private formDataService: FormDataService, 
    private dataService: DataService, 
    private auth: AuthService, 
    private formUpdateService: FormUpdateService) {
  }
  
  ngOnInit(){
    const hseArray = this.formDataService.getHSEDocs();
    this.hse_docs = Array.isArray(hseArray) && hseArray.length > 0 ? hseArray[0] : (hseArray && !Array.isArray(hseArray) ? hseArray : null);

    this.currUser = this.formDataService.getUserData();

    this.initAgreedToSustainabilityChecklist();
    console.log("HSE: ", this.hse_docs);
  }


  ngOnChanges(changes: SimpleChanges) {
    if (changes['formData']){
      if (this.formData?.hse_docs) {
        this.hse_docs = Array.isArray(this.formData.hse_docs) && this.formData.hse_docs.length > 0
          ? this.formData.hse_docs[0]
          : this.formData.hse_docs;
        this.initAgreedToSustainabilityChecklist();
      }
    }
  }

  private initAgreedToSustainabilityChecklist(): void {
    if (this.hse_docs != null) {
      if (!('agreedToSustainabilityChecklist' in this.hse_docs)) {
        this.hse_docs.agreedToSustainabilityChecklist = false;
      }
      this.agreedSustainability = this.hse_docs.agreedToSustainabilityChecklist === true;
    }
  }

  resetErrorMessage() {
    this.error_message = "";
  }
  
  onFileSelected(event: Event, fileType: string) {
    const input = event.target as HTMLInputElement;
    
    
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
  
      //pdf only
      if (file.type !== 'application/pdf') {
        alert('Only PDF files are allowed.');
        input.value = ''; // Clear the file input
        this.error_message = '';
        return;
      }

      // FILE SIZE LIMIT
      const fileSizeLimit = 10 * 1024 * 1024; // 10 MB
      if (file.size > fileSizeLimit) {
        alert('The file is too large. Please select a file smaller than 20 MB.');
        input.value = ''; // Clear the file input
        return;
      }

      switch (fileType) {
        case 'safe':
          this.hse_docs.safetyFile = file;
          this.error_message = '';
          break;
        case 'training':
          this.hse_docs.trainingFile = file;
          this.error_message = '';
          break;
        case 'resources':
          this.hse_docs.resourcesFile = file;
          this.error_message = '';
          break;
      }
    }
  }

  validatefields(): boolean {
    console.log("HSE Doc Data: ", this.hse_docs);

    if (!this.hse_docs) {
      this.error_message = 'Health & Safety data is not loaded. Please refresh and try again.';
      return false;
    }

    if (!this.agreedSustainability){
      this.error_message = "You must agree to completing the Sustainability Checklist to proceed.";
      return false
    }

    // ensure all are responded to:
    if (!this.hse_docs.hasResourcesFile || !this.hse_docs.hasSafetyFile || !this.hse_docs.hasTrainingFile){
      this.error_message = 'Please respond to all sections.'
    }

    if (this.hse_docs.hasResourcesFile === 'yes' && !this.hse_docs.resourcesFile && !this.hse_docs.resourcesFilePath){
      this.error_message = 'Please upload document for section 3'
    }

    if (this.hse_docs.hasSafetyFile === 'yes' && !this.hse_docs.safetyFile && !this.hse_docs.safetyFilePath){
      this.error_message = 'Please upload document for section 1'
    }

    if (this.hse_docs.hasTrainingFile === 'yes' && !this.hse_docs.trainingFile && !this.hse_docs.trainingFilePath){
      this.error_message = 'Please upload document for section 2';
    }

    return true;
  }

  async onSubmit(): Promise<boolean>{
    if (!this.validatefields()) {
      return false; // Validation failed
    }
    if (this.error_message !== "") {
      return false; // Error message present, do not proceed
    }

    this.loading = true;
    this.error_message = "";

    //Save Locally (include sustainability checklist agreement for backend companyhse.agreedToSustainabilityChecklist)
    this.formDataService.updateHSEDocs({ ...this.hse_docs, agreedToSustainabilityChecklist: this.agreedSustainability });

    //SAVE hse TO DB
    try {
      await firstValueFrom(
        this.formUpdateService.updateHSE(this.formDataService.getCurrCompanyID())
      );
       this.loading = false;
      return true;
    } catch (error) {
      this.error_message = "There was an issue saving. Please try again.";
      this.loading = false;
      return false;
    }
  }


}
